// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__deRyR","label":"CategoryService_label__1oNHo","location":"CategoryService_location__Tn9Mc"};